import React, { useState, useRef, useCallback, useEffect } from "react";
import ImageUploader from "react-images-upload";

import { Router, Link } from "@reach/router";
import styles from "./Map.module.scss";
import { useForm } from "react-hook-form";
import * as firebase from "firebase/app";
import "firebase/firestore";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import { formatRelative } from "date-fns";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import {
  Combobox,
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption,
} from "@reach/combobox";
import mapApiKey from "../apikeys";
import MicrobeNpc from "./MicrobeNpc";
import Owl from "./NPCs/Owl.jsx";
import Ant from "./NPCs/Ant.jsx";
import Beach from "./NPCs/Beach.jsx";
import Bee from "./NPCs/Bee.jsx";
import Blackbird from "./NPCs/Blackbird.jsx";
import Cabbage from "./NPCs/Cabbage.jsx";
import Everton from "./NPCs/Everton.jsx";
import Fly from "./NPCs/Fly.jsx";
import Horse from "./NPCs/Horse.jsx";
import Nettles from "./NPCs/Nettles.jsx";
import PlaneTree from "./NPCs/PlaneTree.jsx";
import Quarry from "./NPCs/Quarry.jsx";
import Seagull from "./NPCs/Seagull.jsx";
import Event1 from "./Event1.jsx";
import "@reach/combobox/styles.css";
import mapStyles from "../mapStyles";
import firebaseConfig from "../firebase";
import db from "../firestoreInit";
import Leaderboard from "./Leaderboard";
import Unmoderated from "./Unmoderated";
import Answers from "./Answers";
import Questions from "./Questions";
import Casefile from "./Casefile";
import Title from "../Non-humans title gif/Title.gif";
import Food from "../Static assets/Shapes/food.svg";
import Pollution from "../Static assets/Shapes/pollution.svg";
import Crime from "../Static assets/Shapes/crime.svg";
import Behavior from "../Static assets/Shapes/behavior.svg";
import Space from "../Static assets/Shapes/space.svg";
import Health from "../Static assets/Shapes/health.svg";
import DateCountdown from "react-date-countdown-timer";
import OwlTwo from "./NPCs/Owl2";
import Cat from "./NPCs/Cat";
import Fox from "./NPCs/Fox";
import Tulip from "./NPCs/Tulip";
import AntTwo from "./NPCs/Ant2";
require("firebase/firestore");

const libraries = ["places"];

const center = { lat: 53.402272, lng: -2.977405 };
const options = {
  styles: mapStyles,
  disableDefaultUI: true,
  zoomControl: true,
};

function Map(props) {
  const [markers, setMarkers] = React.useState([]);
  const [selected, setSelected] = React.useState(null);
  const [message, setMessage] = React.useState([]);
  const [showComment, setShowComment] = React.useState(false);
  const [currentMarker, setCurrentMarker] = React.useState(null);
  const [filter, setCurrentFilter] = React.useState(null);
  const [database, setDatabase] = React.useState(props.alpha);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: mapApiKey,
    libraries,
  });
  const localName = localStorage.getItem("factWhatIfUsername");

  const ResponsiveLayout = () => {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
      const handleResize = () => {
        setWidth(window.innerWidth);
      };
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
    return width > 961
      ? {
          positon: "relative",
          height: "100vh",
          width: "100vw",
        }
      : {
          positon: "relative",
          height: "60vh",
          width: "100vw",
        };
  };

  const mapContainterStyle = ResponsiveLayout();

  function Comment() {
    const { register, handleSubmit } = useForm();
    const [report, setReport] = React.useState({ post: false });
    const handleClick = () => {
      setShowComment(false);
    };
    console.log(currentMarker, selected, "currentMarker");

    const postMarker = (data) => {
      setShowComment(false);
      console.log(data);
      db.collection(`${database}`)
        .add({
          username: localName,
          lat: currentMarker.lat,
          lng: currentMarker.lng,
          time: currentMarker.time,
          folk: data.folk,
          nonhumantype: data.nonhumantype,
          allegation: data.allegation,
          affected: data.affected,
          problem: data.problem,
          feelings: data.feelings,
          better: data.better,
          video: data.video,
          link: data.link,
          link2: data.link2,
          link3: data.link3,
          image: data.image,
          solution: data.solution,
          url: data.url,
          moderated: false,
          //       image: data.file[0],
        })
        .then(function (docRef) {
          const imageRef = console.log("Document written with ID: ", docRef.id);

          setMarkers((current) => [
            ...current,
            {
              username: localName,
              lat: currentMarker.lat,
              lng: currentMarker.lng,
              time: currentMarker.time,
              folk: data.folk,
              nonhumantype: data.nonhumantype,
              allegation: data.allegation,
              affected: data.affected,
              problem: data.problem,
              feelings: data.feelings,
              better: data.better,
              video: data.video,
              link: data.link,
              link2: data.link2,
              link3: data.link3,
              image: data.image,
              solution: data.solution,
              id: docRef.id,
              url: data.url,
              comments: [""],
              moderated: false,
            },
          ]);
        })
        .catch(function (error) {
          console.error("Error adding document: ", error);
        });

      setMessage((current) => [...current, { msg: data.allegation }]);
    };
    useEffect(() => {
      console.log(report);
      if (report.post) {
        db.collection(`${database}`)
          .add(report)
          .then(function (docRef) {
            console.log("Document written with ID: ", docRef.id);
            if (report.post) {
              setMarkers((current) => [...current, report]);
              handleClick();
            }
            setReport({ post: false });
          });
      }
    }, [report]);

    return (
      <Questions
        postMarker={postMarker}
        setReport={setReport}
        currentMarker={currentMarker}
        type={props.type}
        handleClick={handleClick}
        setShowComment={setShowComment}
        setSelected={setSelected}
      />
    );
  }

  function ShowComments() {
    console.log(selected.id);
    const { register, handleSubmit } = useForm();
    const onSubmit = (data) => {
      db.collection(`${database}`)
        .doc(selected.id)
        .update({ comments: [...selected.comments, data.comment] })
        .then(function (docRef) {
          console.log("data returned: ", docRef);
        })
        .catch(function (error) {
          console.error("Error adding document: ", error);
        });
    };

    const handleClick = () => {
      setSelected(null);
    };

    return (
      <div className={styles.box}>
        {selected.npc === "ant2" ? (
          <AntTwo selected={selected} setSelected={setSelected} />
        ) : selected.npc === "tulip" ? (
          <Tulip selected={selected} setSelected={setSelected} />
        ) : selected.npc === "fox" ? (
          <Fox selected={selected} setSelected={setSelected} />
        ) : selected.npc === "cat" ? (
          <Cat selected={selected} setSelected={setSelected} />
        ) : selected.npc === "owl2" ? (
          <OwlTwo selected={selected} setSelected={setSelected} />
        ) : selected.npc === "event1" ? (
          <Event1 selected={selected} setSelected={setSelected} />
        ) : selected.npc === "microbe" ? (
          <MicrobeNpc setSelected={setSelected} />
        ) : selected.npc === "ant" ? (
          <Ant setSelected={setSelected} />
        ) : selected.npc === "beach" ? (
          <Beach setSelected={setSelected} />
        ) : selected.npc === "bee" ? (
          <Bee setSelected={setSelected} />
        ) : selected.npc === "blackbird" ? (
          <Blackbird setSelected={setSelected} />
        ) : selected.npc === "cabbage" ? (
          <Cabbage setSelected={setSelected} />
        ) : selected.npc === "everton" ? (
          <Everton setSelected={setSelected} />
        ) : selected.npc === "fly" ? (
          <Fly setSelected={setSelected} />
        ) : selected.npc === "horse" ? (
          <Horse setSelected={setSelected} />
        ) : selected.npc === "nettles" ? (
          <Nettles setSelected={setSelected} />
        ) : selected.npc === "owl" ? (
          <Owl setSelected={setSelected} />
        ) : selected.npc === "planetree" ? (
          <PlaneTree setSelected={setSelected} />
        ) : selected.npc === "quarry" ? (
          <Quarry setSelected={setSelected} />
        ) : selected.npc === "seagull" ? (
          <Seagull setSelected={setSelected} />
        ) : selected.moderated === false ? (
          <Unmoderated setSelected={setSelected} />
        ) : (
          <Answers
            selected={selected}
            setSelected={setSelected}
            setShowComment={setShowComment}
          />
        )}
      </div>
      // <div className={styles.commentBox}>
      //   <button onClick={handleClick}>[x]</button>

      //   <p>
      //     <b>What kind of non-human are you?</b>
      //   </p>
      //   <p> {selected.nonhumantype}</p>
      //   <p>
      //     <b>In your own words, what happened to you?</b>
      //   </p>
      //   <p> {selected.allegation}</p>
      //   <p>
      //     <b>Why is that a problem?</b>
      //   </p>

      //   <p> {selected.problem}</p>
      //   <p>
      //     {" "}
      //     <b>How do you feel</b>
      //   </p>

      //   <p> {selected.feelings}</p>
      //   <p>
      //     {" "}
      //     <b>What evidence do you have to prove your statement?</b>
      //   </p>

      //   <p> {selected.evidence}</p>
      //   <img src={selected.image} />
      //   <p>
      //     {" "}
      //     <b>Who is affected by this?</b>
      //   </p>

      //   <p> {selected.affected}</p>
      //   <p>
      //     <b>How could this problem be solved?</b>
      //   </p>
      //   <p>{selected.solution}</p>
      //   <p>
      //     {" "}
      //     <b>
      //       Imagine what humans might say to convince people that this problem
      //       doesn't really matter, how would you argue against this?
      //     </b>
      //   </p>

      //   <p> {selected.argument}</p>
      // </div>
    );
  }

  const onMapClick = React.useCallback((event) => {
    //   const mess = prompt("What ill deeds are done here?", "Cat Crimes!");
    //   setMessage((current) => [...current, { msg: mess }]);
    console.log(event);
    setShowComment(true);
    setCurrentMarker({
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
      time: new Date(),
    });
  }, []);

  {
    /* {      setMarkers((current) => [
       ...current,// link2: data.link2,

      {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
        time: new Date(),
        msg: message,
      },
    ]);
  }, []); */
  }

  const mapRef = React.useRef();
  const onMapLoad = React.useCallback((map) => {
    mapRef.current = map;
    if (markers.length === 0) {
      db.collection(`${database}`)
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            setMarkers((current) => [
              ...current,
              {
                username: doc.data().username,
                image: doc.data().image,
                text: doc.data().text,
                npc: doc.data().npc,
                lat: doc.data().lat,
                lng: doc.data().lng,
                // time: doc.data().time.toDate(),
                folk: doc.data().folk,
                solutiondefense: doc.data().solutiondefense,
                incidenttype: doc.data().incidenttype,
                link: doc.data().link,
                link2: doc.data().link2,
                link3: doc.data().link3,
                link1description: doc.data().link1description,
                link2description: doc.data().link2description,
                link3description: doc.data().link3description,
                vid1: doc.data().vid1,
                vid2: doc.data().vid2,
                vid3: doc.data().vid3,
                photo1: doc.data().photo1,
                photo2: doc.data().photo2,
                photo3: doc.data().photo3,
                allegation: doc.data().allegation,
                conflict: doc.data().conflict,
                nonhumantype: doc.data().nonhumantype,
                problem: doc.data().problem,
                solution: doc.data().solution,
                affected: doc.data().affected,
                argument: doc.data().argument,
                id: doc.id,
                comments: doc.data().comments,
                url: doc.data().url,
                points: doc.data().points,
                moderated: doc.data().moderated,
                better: doc.data().better,
                message: doc.data().message,
                feelings: doc.data().feelings,
              },
            ]);

            // markers.forEach((marker) => {
            //   if (marker.moderated === true) {
            //     tournament[marker.folk] += marker.points;
            //   }
            //   console.log("moderated");
            //   console.log(tournament);
            // });
            // console.log(tournament);
          });
        });
    }
  }, []);

  function tournament() {
    let tournamentNumbers = {
      mammal: 0,
      bird: 0,
      plant: 0,
      water: 0,
      "natural feature": 0,
      insect: 0,
    };

    if (markers.length > 0) {
      markers.forEach((marker) => {
        const flk = marker.folk;
        if (marker.moderated === true) {
          tournamentNumbers[flk] += marker.points;
        }
      });
    }
    return tournamentNumbers;
  }

  const panTo = React.useCallback(({ lat, lng }) => {
    mapRef.current.panTo({ lat, lng });
    mapRef.current.setZoom(15);
  }, []);
  if (loadError) return "Error loading maps";
  if (!isLoaded) return "Loading Maps";

  const toggleName = () => {
    filter === "name" ? setCurrentFilter(null) : setCurrentFilter("name");
  };

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <h1>HOW TO PLAY</h1>
        <article>
          Click anywhere on the map to leave a non-human incident report which
          will be moderated and scored. At the end of the tournament, each folk
          will present their most convincing report to a jury who will award
          extra prize points. The Folk with the highest cumulative points wins.
        </article>
        {localStorage.getItem("factWhatIfUsername") !== "" && (
          <button onClick={toggleName}>
            {filter === "name" && <p>Show All Markers</p>}
            {filter !== "name" && <p>Show My Markers Only</p>}
          </button>
        )}
        <p className={styles.findOutMore}>
          <Link to={"/inst/" + props.alpha + "/" + props.type + ""}>
            What Makes a Good Marker?
          </Link>
        </p>
        <p className={styles.findOutMore}>
          <Link to={"/about/" + props.alpha + "/" + props.type + ""}>
            About the Project
          </Link>
        </p>
        <aside className={styles.countdown}>
          <b>Time Left Until Tournament Ends: </b>
          <br />
          <DateCountdown
            dateTo="February 05, 2021 00:00:00 GMT+03:00"
            callback={() => {
              return null;
            }}
          />
        </aside>

        <div className={styles.logoContainer}>
          <ul>
            <li>
              <img className={styles.glyph} src={Food} />
              FOOD
            </li>
            <li>
              <img className={styles.glyph} src={Pollution} />
              POLLUTION
            </li>
            <li>
              <img className={styles.glyph} src={Behavior} />
              BEHAVIOUR
            </li>
            <li>
              <img className={styles.glyph} src={Space} />
              SPACE
            </li>
            <li>
              <img className={styles.glyph} src={Crime} />
              CRIME
            </li>
            <li>
              <img className={styles.glyph} src={Health} />
              HEALTH
            </li>
          </ul>
          <br />
          <img
            className={styles.logo}
            src={Title}
            alt="Nonhumans of Liverpool"
          />
        </div>
      </div>
      <div className={styles.mid}>
        <Leaderboard
          tournament={tournament}
          setCurrentFilter={setCurrentFilter}
        />
      </div>
      <div className={styles.right}>
        <GoogleMap
          className={styles.googleMapContainer}
          mapContainerStyle={mapContainterStyle}
          zoom={15}
          center={center}
          options={options}
          onClick={onMapClick}
          onLoad={onMapLoad}
        >
          {selected && <ShowComments className={styles.box} />}
          <nav className="navigation">
            <Search panTo={panTo} className={styles.search} />
            <Locate panTo={panTo} className={styles.compass} />
          </nav>
          {showComment && (
            <>
              {/* <CaseFile submitMarker={submitMarker} /> */}
              <Comment />
            </>
          )}
          {filter === null
            ? markers.length > 0 &&
              markers.map((marker) => (
                <Marker
                  // key={marker.time.toISOString()}
                  position={{ lat: marker.lat, lng: marker.lng }}
                  icon={{
                    url: marker.url,
                    scaledSize: new window.google.maps.Size(30, 30),
                    origin: new window.google.maps.Point(0.0),
                    anchor: new window.google.maps.Point(0, 0),
                  }}
                  onClick={() => {
                    setSelected(marker);
                    console.log(selected);
                  }}
                />
              ))
            : filter === "name"
            ? markers.length > 0 &&
              markers.map((marker) => {
                if (marker.username === localName) {
                  return (
                    <Marker
                      // key={marker.time.toISOString()}
                      position={{ lat: marker.lat, lng: marker.lng }}
                      icon={{
                        url: marker.url,
                        scaledSize: new window.google.maps.Size(30, 30),
                        origin: new window.google.maps.Point(0.0),
                        anchor: new window.google.maps.Point(0, 0),
                      }}
                      onClick={() => {
                        setSelected(marker);
                        console.log(selected);
                      }}
                    />
                  );
                }
              })
            : filter === "best"
            ? markers.length > 0 &&
              markers.map((marker) => {
                if (
                  marker.url ===
                  "https://raw.githubusercontent.com/conwayhub/markertests/master/Shapes/MarkerOfTheWeek.jpg"
                ) {
                  return (
                    <Marker
                      // key={marker.time.toISOString()}
                      position={{ lat: marker.lat, lng: marker.lng }}
                      icon={{
                        url: marker.url,
                        scaledSize: new window.google.maps.Size(30, 30),
                        origin: new window.google.maps.Point(0.0),
                        anchor: new window.google.maps.Point(0, 0),
                      }}
                      onClick={() => {
                        setSelected(marker);
                        console.log(selected);
                      }}
                    />
                  );
                }
              })
            : markers.length > 0 &&
              markers.map((marker) => {
                if (marker.folk === filter) {
                  return (
                    <Marker
                      // key={marker.time.toISOString()}
                      position={{ lat: marker.lat, lng: marker.lng }}
                      icon={{
                        url: marker.url,
                        scaledSize: new window.google.maps.Size(30, 30),
                        origin: new window.google.maps.Point(0.0),
                        anchor: new window.google.maps.Point(0, 0),
                      }}
                      onClick={() => {
                        setSelected(marker);
                        console.log(selected);
                      }}
                    />
                  );
                }
              })}

          {/* {selected ? (
            <InfoWindow
              position={{ lat: selected.lat, lng: selected.lng }}
              onCloseClick={() => {
                setSelected(null);
              }}
            >
              <div></div>
            </InfoWindow>
          ) : null} */}
        </GoogleMap>
      </div>
    </div>
  );
}

function Locate({ panTo }) {
  return (
    <button
      className={styles.compass}
      onClick={() => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            panTo({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
          },
          () => null
        );
      }}
    >
      Compass
    </button>
  );
}

function Search({ panTo }) {
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      location: { lat: () => 53.402272, lng: () => -2.977405 },
      radius: 100 * 1000,
    },
  });

  return (
    <div className={styles.search}>
      <Combobox
        onSelect={async (address) => {
          setValue(address, false);
          clearSuggestions();
          try {
            const results = await getGeocode({ address });
            const { lat, lng } = await getLatLng(results[0]);
            console.log(results);
            panTo({ lat, lng });
          } catch (error) {
            console.log("error >" + error);
          }
          console.log(address);
        }}
      >
        <ComboboxInput
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          disabled={!ready}
          placeholder="Enter an address"
        />
        <ComboboxPopover className={styles.addList}>
          <ComboboxList>
            {status === "OK" &&
              data.map(({ id, description }) => (
                <ComboboxOption key={id} value={description} />
              ))}
          </ComboboxList>
        </ComboboxPopover>
      </Combobox>
    </div>
  );
}

export default Map;
